// Action Types
export const typePrefix = 'vra/trialPlacementOptions/';
export const actions = [
  'SET_TRIAL_PLACEMENT_OPTIONS'
].reduce((result, key) => { result[key] = `${typePrefix}${key}`; return result; }, {});

// Reducers
export default function reducer(
  state = {},
  action = {}
) {
  switch (action.type) {
    case actions.SET_TRIAL_PLACEMENT_OPTIONS:
      return action.payload.trialPlacementOptions;
    default:
      return state;
  }
}

export const setTrialPlacementOptions = (trialPlacementOptions) => ({
  type: actions.SET_TRIAL_PLACEMENT_OPTIONS,
  payload: {
    trialPlacementOptions
  }
});